export const HEADER_ENTITY_NAME = 'cardfinder_flow_header';
export const HEADER_ACTION_NAME = 'cardfinder_explore_card_types_click';

export const PICKER_ENTITY_NAME = 'cardfinder_card_type_modal';
export const PICKER_ACTION_NAME = 'cardfinder_card_type_modal_select';
export const PICKER_CLOSE_ACTION_INPUT = 'close';
